import { withStyles } from '@material-ui/core/styles';

import { withBaseSelect } from "shared/HOC";

const useStyles = {
    formControl: {
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: "16px",
    },
};

const DEFAULT_SEASONS = [
    { value: 'All Year', label: 'All Year' },
    { value: 'Summer', label: 'Summer' },
    { value: 'Winter', label: 'Winter' }
];

const SeasonSelect = withBaseSelect(DEFAULT_SEASONS);
export default withStyles(useStyles)(SeasonSelect);
